import { render, staticRenderFns } from "./CatalogsBaseFormLabels.vue?vue&type=template&id=6ab55e1f&"
import script from "./CatalogsBaseFormLabels.vue?vue&type=script&lang=js&"
export * from "./CatalogsBaseFormLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QItem,QField,QCheckbox,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCard,QItem,QField,QCheckbox,QInnerLoading,QSpinnerGears}, component.options.components || {})
